{
  "list": {
    "title": "إدارة العملاء",
    "add": "إضافة عميل",
    "searchLabel": "البحث بالاسم أو الهاتف أو رقم الوثيقة",
    "filters": {
      "level": "المستوى",
      "allLevels": "جميع المستويات",
      "category": "التصنيف",
      "allCategories": "جميع التصنيفات",
      "system": "النظام",
      "allSystems": "جميع الأنظمة",
      "status": "الحالة",
      "active": "نشط",
      "deleted": "محذوف"
    },
    "columns": {
      "name": "الاسم",
      "phone": "الهاتف",
      "level": "المستوى",
      "category": "التصنيف",
      "systems": "الأنظمة",
      "createdAt": "تاريخ الإنشاء",
      "createdBy": "تم الإنشاء بواسطة"
    },
    "noCategory": "بدون تصنيف",
    "rowActions": {
      "trigger": "إجراءات {{name}}"
    }
  },
  "drawer": {
    "createTitle": "إضافة عميل",
    "editTitle": "تعديل العميل",
    "createDescription": "سجل عميلا جديدا برقم هاتف وأي بيانات معروفة عنه.",
    "editDescription": "تحديث بيانات هذا العميل.",
    "fields": {
      "phone": "الهاتف",
      "fullName": "الاسم الكامل",
      "documentType": "نوع الوثيقة",
      "documentTypeNone": "بدون",
      "documentTypeNationalId": "هوية وطنية",
      "documentTypePassport": "جواز سفر",
      "documentNumber": "رقم الوثيقة",
      "documentCountry": "دولة الإصدار",
      "documentCountryPlaceholder": "اختر دولة",
      "documentCountrySearch": "ابحث عن دولة...",
      "category": "التصنيف"
    },
    "levelHint": "سيكون مستوى هذا العميل {{level}} بعد الحفظ",
    "phoneTaken": "رقم الهاتف مسجل لعميل آخر.",
    "documentTaken": "الوثيقة مسجلة لعميل آخر.",
    "phoneTakenBy": "رقم الهاتف مسجل لعميل آخر: {{name}}",
    "documentTakenBy": "الوثيقة مسجلة لعميل آخر: {{name}}",
    "viewExistingCustomer": "عرض العميل",
    "created": "تم إنشاء العميل بنجاح",
    "updated": "تم تحديث العميل بنجاح"
  },
  "detail": {
    "title": "تفاصيل العميل",
    "noName": "لا يوجد اسم مسجل",
    "sections": {
      "basicInfo": "المعلومات الأساسية",
      "systems": "الأنظمة",
      "movements": "الحركات"
    },
    "noSystems": "هذا العميل غير مسجل في أي نظام حتى الآن.",
    "firstSeen": "الأول: {{date}}",
    "lastSeen": "الأخير: {{date}}",
    "movementTypes": {
      "exchange": "عملية صرف",
      "sale": "بيع",
      "fuelDebtCharge": "بيع ذمم",
      "fuelDebtRepayment": "سداد ذمم",
      "fuelPurchase": "شراء",
      "fuelSale": "بيع نقدي",
      "deposit": "إيداع أمانة",
      "delivery": "تسليم أمانة",
      "return": "استرداد أمانة",
      "transferSent": "حوالة — مرسل",
      "transferReceived": "حوالة — مستلم",
      "transferSelf": "حوالة — مرسل ومستلم",
      "debtDebit": "ذمم — مدين",
      "debtCredit": "ذمم — دائن"
    },
    "movementsColumns": {
      "date": "التاريخ",
      "system": "النظام",
      "branch": "الفرع",
      "type": "نوع الحركة",
      "reference": "الرقم المرجعي",
      "amount": "المبلغ",
      "employee": "الموظف",
      "fieldEmployee": "موظف الميدان",
      "reversedBy": "تم العكس بواسطة"
    },
    "deleted": "تم حذف العميل بنجاح",
    "restored": "تم استعادة العميل بنجاح",
    "deleteConfirmTitle": "حذف هذا العميل؟",
    "deleteConfirmDescription": "سيتم إخفاء {{name}} من القوائم والبحث. تبقى حركاته محفوظة، ويمكن لمستخدم مخول استعادته لاحقا.",
    "restoreConfirmTitle": "استعادة هذا العميل؟",
    "restoreConfirmDescription": "سيظهر {{name}} من جديد في القوائم والبحث.",
    "createdBy": "تم الإنشاء بواسطة",
    "updatedBy": "تم التحديث بواسطة",
    "createdVia": "عبر {{system}}",
    "unknownBranch": "فرع غير معروف",
    "preparingPrint": "جاري إعداد الطباعة...",
    "printFailed": "تعذر إعداد كشف العميل. حاول الطباعة مرة أخرى."
  }
}
